module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05IDFMMTEuMzUxMSA1Ljc2MzkzTDE2LjYwODUgNi41Mjc4NkwxMi44MDQyIDEwLjIzNjFMMTMuNzAyMyAxNS40NzIxTDkgMTNMNC4yOTc3MiAxNS40NzIxTDUuMTk1NzcgMTAuMjM2MUwxLjM5MTU1IDYuNTI3ODZMNi42NDg4NiA1Ljc2MzkzTDkgMVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./depohost.ru/local/templates/depohost/pictures/icons/star.svg
// module id = 20
// module chunks = 0